/** Paths that use UserDashboardLayout + member sidebar (keep in sync with layout route list). */
export const isMemberAppPath = (pathname: string) =>
  pathname.startsWith("/my-dashboard") ||
  pathname.startsWith("/my-tickets") ||
  pathname.startsWith("/id-card") ||
  pathname.startsWith("/my-plan") ||
  pathname.startsWith("/renew") ||
  pathname.startsWith("/notifications") ||
  pathname.startsWith("/activity-logs") ||
  pathname.startsWith("/shop-management");
